import React from 'react';
import { PortableText } from '@portabletext/react';
import { Text as ChakraText } from '@chakra-ui/react';
import { components } from './components';

export default function RichText(props) {
  const { value, ...restProps } = props;
  return (
    <ChakraText as='div' {...restProps} className='rich-text'>
      <PortableText value={value} components={components} />
    </ChakraText>
  );
}
